export default "__VITE_PUBLIC_ASSET__fd2c2170__"